var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaletteSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M576,320c0,0.9,0,1.8,0,2.7c-0.4,36.5-33.6,61.3-70.1,61.3H408c-26.5,0-48,21.5-48,48c0,3.4,0.4,6.7,1,9.9 c2.1,10.2,6.5,20,10.8,29.9c6.1,13.8,12.1,27.5,12.1,42c0,31.8-21.6,60.7-53.4,62c-3.5,0.1-7,0.2-10.6,0.2 c-141.4,0-256-114.6-256-256S178.6,64,320,64S576,178.6,576,320z M192,352c0-17.7-14.3-32-32-32s-32,14.3-32,32s14.3,32,32,32 S192,369.7,192,352z M192,256c17.7,0,32-14.3,32-32s-14.3-32-32-32s-32,14.3-32,32S174.3,256,192,256z M352,160 c0-17.7-14.3-32-32-32s-32,14.3-32,32s14.3,32,32,32S352,177.7,352,160z M448,256c17.7,0,32-14.3,32-32s-14.3-32-32-32 s-32,14.3-32,32S430.3,256,448,256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaletteSolidFull);
export default __webpack_public_path__ + "static/media/palette-solid-full.b78cc1d303f957fdab4a27d27ae9b88d.svg";
export { ForwardRef as ReactComponent };